import type { SettledMeetingCopy } from '@/app/queries/MeetingContextQuery/useMeetingCopy';

interface LobbyAppointmentProps {
  address: string;
  copy: Pick<SettledMeetingCopy, 'hostTitle' | 'isSettled'>;
  isClient: boolean;
  customerName?: string;
  staffName?: string;
}

const SECTION_LABEL = 'paragraph-3 font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400';
const MUTED = 'text-gray-500 dark:text-gray-400';

export default function LobbyAppointment({
  address, copy, customerName, isClient, staffName,
}: LobbyAppointmentProps) {
  const showsCustomerName = !isClient && Boolean(customerName);
  const showsStaffName = copy.isSettled && Boolean(staffName);

  return (
    <section className="flex flex-col gap-2 pt-6 border-gray-200 dark:border-gray-800 border-t">
      <h2 className={SECTION_LABEL}>Appointment</h2>
      <div className="flex flex-col gap-1">
        <p className="paragraph-2">{address}</p>
        {showsCustomerName && <p className={`paragraph-3 ${MUTED}`}>Customer · {customerName}</p>}
        {showsStaffName && <p className={`paragraph-3 ${MUTED}`}>{copy.hostTitle} · {staffName}</p>}
      </div>
    </section>
  );
}
